import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";

import commoncss from "./../../css/common.module.css";
import libcss from "../../css/library.module.css";
import buttoncss from "./../../css/button.module.css";

import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as RestoreIcon } from "../../assets/icons/repeatIcon.svg";
import {ReactComponent as DownArrow} from "../../assets/icons/down_arrow.svg";

import { restoreDelGroupingApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { MicNone } from "@material-ui/icons";

const RestoreDeletedItemModal = ({
  tempId,
  deletedGroupingData,
  setShowBin,
}) => {
  const [tab, setTab] = useState("level1");
  const [openCategory, setOpenCategory] = useState(null);
  
  const safeDeletedData = Array.isArray(deletedGroupingData)
    ? deletedGroupingData
    : [];

  
  const [selectedItems, setSelectedItems] = useState({});

  const categories = [
    ...new Set(safeDeletedData.map((o) => o.category)),
  ];

  useEffect(() => {
    const levelMap = { level1: 1, level2: 2, level3: 3 };
    const levelNum = levelMap[tab];
    const firstCat = categories.find((cat) =>
      safeDeletedData.some((o) => o.category === cat && o.level === levelNum)
    );
    if (firstCat) {
      setOpenCategory(firstCat);
    }
  }, [tab, safeDeletedData]);

  

  const getSelected = (category, levelKey) =>
    selectedItems?.[category]?.[levelKey] || [];

  const getAllLevelIds = (catItems, level) =>
    catItems
      .filter((o) => o?.level === level)
      .map((o) => o._id)
      .filter(Boolean);

  const handleToggleItem = (category, levelKey, id) => {
    if (!id) return;

    setSelectedItems((prev) => {
      const prevCat = prev[category] || {
        level1: [],
        level2: [],
        level3: [],
      };

      const set = new Set(prevCat[levelKey]);
      set.has(id) ? set.delete(id) : set.add(id);

      return {
        ...prev,
        [category]: {
          ...prevCat,
          [levelKey]: Array.from(set),
        },
      };
    });
  };

  const handleSelectAllForLevel = (
    category,
    levelKey,
    checked,
    catItems
  ) => {
    const levelMap = { level1: 1, level2: 2, level3: 3 };
    const ids = getAllLevelIds(catItems, levelMap[levelKey]);

    setSelectedItems((prev) => ({
      ...prev,
      [category]: {
        ...(prev[category] || {}),
        [levelKey]: checked ? ids : [],
      },
    }));
  };

  /* ---------------- RESTORE ---------------- */

  const restoreItem = (id) => {
    if (!id) return;

    restoreDelGroupingApiHandler({
      groupingTemplateID: tempId,
      deletedGroupingID: id,
    })
      .then((res) => {
        if (res?.data?.success) {
          setShowBin(false);
        } else {
          toast.error("Restore failed");
        }
      })
      .catch(() => toast.error("Restore failed"));
  };

  const restoreSelectedItems = () => {
    const ids = [];

    categories.forEach((cat) => {
      const sel = selectedItems[cat];
      if (!sel) return;

      ["level1", "level2", "level3"].forEach((lvl) => {
        (sel[lvl] || []).forEach((id) => id && ids.push(id));
      });
    });

    if (!ids.length) {
      toast.info("No items selected");
      return;
    }
    const payload = {deletedGroupingID:ids}
    restoreDelGroupingApiHandler({
      groupingTemplateID: tempId
    },payload)
      .then((res) => {
        if (res?.data?.success) {
          setShowBin(false);
        } else {
          toast.error("Restore failed");
        }
      })
      .catch(() => toast.error("Restore failed"));
  };

  /* ---------------- UI ---------------- */

  const renderLevel = (levelKey, levelNum, labelKey) => (
    <div className={libcss.levelCatDiv}>
      {categories.map((category) => {
        const catItems = safeDeletedData.filter(
          (o) => o.category === category
        );

        const levelItems = catItems.filter(
          (o) => o.level === levelNum
        );

        // 🔥 KEY FIX: hide category if no items for this level
        if (levelItems.length === 0) return null;

        const allIds = getAllLevelIds(catItems, levelNum);
        const selected = getSelected(category, levelKey);
        const allSelected =
          allIds.length > 0 &&
          allIds.every((id) => selected.includes(id));

        return (
          <div key={category} className={libcss.levelCat}>
            <div className={libcss.levelCatLabelWrapper}
            style={{ 
              borderBottom: "1px solid #eaeeed",
              background: openCategory === category ? "#f8f9f9" : "transparent",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px"
            }}>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) =>
                  handleSelectAllForLevel(
                    category,
                    levelKey,
                    e.target.checked,
                    catItems
                  )
                }
              />
              <span className={libcss.levelCatLabel} style={{ borderBottom: "none" }}>{category} </span>
              <DownArrow
                style={{
                  marginLeft: "auto",
                  marginRight: "6px",
                  cursor: "pointer",
                  transform: openCategory === category ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "0.2s",
                }}
                onClick={(e) => {
                  e.stopPropagation(); 
                  setOpenCategory(openCategory === category ? null : category);
                }}
              />
              </div>
            
          {openCategory === category && (
            <div className={libcss.levelCatDiv} style={{ gap: "0" }}>
              {levelItems.map((obj) => (
                <div
                  key={obj._id}
                  className={`${libcss.levelItem} ${commoncss.clickable}`}
                   style={{ border: "none", padding: "6px 0", background: "#ffffff" }} >
                  <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(obj._id)}
                      onChange={() =>
                        handleToggleItem(
                          category,
                          levelKey,
                          obj._id
                        )
                      }
                    />
                    <span>{obj[labelKey] || obj.name}</span>
                  </span>

                  <RestoreIcon
                   style={{ width: "24px", height: "24px",paddingRight: "8px"}}
                    onClick={() => restoreItem(obj._id)}
                  />
                </div>
              ))}
            </div>
          )}
          </div>
        );
      })}
    </div>
  );

  return (
    <Modal
      width="40%"
      minHeight="300px"
      title="Restore Deleted Items"
      bodycss={commoncss.unsetPadding}
      headerActions={<CloseIcon onClick={() => setShowBin(null)} />}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowBin(null)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Restore Selected Items"
            onClick={restoreSelectedItems}
          />
        </>
      }
    >
      <div>
        <div style={{borderBottom: "1px solid #eaeeed"}}>
          {["level1", "level2", "level3"].map((l, i) => (
            <button
              key={l}
              className={`tab-button ${tab === l ? "active" : ""}`}
              onClick={() => setTab(l)}
              style={{
              borderBottom: "none",        
              paddingBottom: "10px",       
            }}
            >
              Level {i + 1}
            </button>
          ))}
        </div>

        {tab === "level1" &&
          renderLevel("level1", 1, "levelOne")}
        {tab === "level2" &&
          renderLevel("level2", 2, "levelTwo")}
        {tab === "level3" &&
          renderLevel("level3", 3, "levelThree")}
      </div>
    </Modal>
  );
};

export default RestoreDeletedItemModal;
